module.exports = __webpack_public_path__ + "Simple-Line-Icons.f33df365d6d0255b586f.eot";


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/assets/fonts/Simple-Line-Icons.eot?v=2.4.0
// module id = ../../../../../src/assets/fonts/Simple-Line-Icons.eot?v=2.4.0
// module chunks = styles